import {
  Planzone,
  CalendarHolidays,
  Identifiable,
  Holiday,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateHoliday(httpClient: HttpClient, holiday: Holiday) {
  return httpClient
    .sendHttpRequest<Holiday>({
      endpoint: `/holidays/${holiday.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        name: holiday.name,
        day: holiday.day,
        holidayDate: holiday.holidayDate,
      },
    })
    .then((updatedHoliday) => updatedHoliday)
    .catch((error) => Promise.reject({ ...error, message: error.detail }));
}

function createHoliday(
  httpClient: HttpClient,
  calendarHolidays: Identifiable<CalendarHolidays>,
  holiday: Holiday,
) {
  return httpClient
    .sendHttpRequest<Identifiable<Holiday>>({
      endpoint: "/holidays",
      method: HttpMethods.POST,
      data: {
        calendarHolidays: `/calendarHolidayses/${calendarHolidays.uuid}`,
        name: holiday.name,
        day: holiday.day,
        holidayDate: holiday.holidayDate,
      },
    })
    .then((newHoliday) => newHoliday)
    .catch((error) => Promise.reject({ ...error, message: error.detail }));
}

function updateCalendar(
  httpClient: HttpClient,
  planzone: Planzone,
  calendarHolidays: Identifiable<CalendarHolidays>,
  nextCalendarHolidays: CalendarHolidays,
) {
  return httpClient
    .sendHttpRequest<Identifiable<CalendarHolidays>>({
      endpoint: `/calendarHolidayses/${calendarHolidays.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        planzone: `/planzones/${planzone.uuid}`,
        name: nextCalendarHolidays.name,
      },
    })
    .then((updatedCalendar) => updatedCalendar)
    .catch((error) => Promise.reject({ ...error, message: error.detail }));
}

function editCalendarHolidays(httpClient: HttpClient) {
  return (
    planzone: Planzone,
    calendarHolidays: Identifiable<CalendarHolidays>,
    nextCalendarHolidays: CalendarHolidays,
  ) => {
    const holidayPromises = nextCalendarHolidays.holidays.map((holiday) => {
      if (holiday.uuid) {
        return updateHoliday(httpClient, holiday);
      } else {
        return createHoliday(httpClient, calendarHolidays, holiday);
      }
    });

    return Promise.all(holidayPromises)
      .then(() => {
        return updateCalendar(
          httpClient,
          planzone,
          calendarHolidays,
          nextCalendarHolidays,
        );
      })
      .then((updatedCalendarHolidays) => {
        return updatedCalendarHolidays;
      })
      .catch((error) =>
        Promise.reject({ ...error, message: error.detail || " " }),
      );
  };
}

export { editCalendarHolidays };
